// src/services/Common Data.ts

export interface ModelRetirementConfig {
    model_value: string;
    status: 'active' | 'retiring' | 'deprecated';
    retirement_date: string | null;
    replacement_model: string;
    message: string;
}

export const fetchModelRetirementConfig = async (): Promise<ModelRetirementConfig[]> => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/config/model-retirement`, {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
        });

        if (!response.ok) {
            console.error('Failed to fetch model retirement config');
            return [];
        }

        const data = await response.json();
        return data.data || [];
    } catch (error) {
        console.error('Error fetching model retirement config:', error);
        return [];
    }
};

export const fetchPromptLibrary = async () => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/common/prompt-libraries`, {
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });
    return await response.json();
};

export const fetchUISettings = async () => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/common/ui-settings`, {
      credentials: 'include'
    });
    return await response.json();
};

export const generateAISummary = async (summaryRequest: {
    net_id: string;
    app_id: string;
    discussion_points: string[];
    user_name: string;
    chat_id?: string;
}) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/common/ai_summary`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(summaryRequest),
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to generate AI summary: ${response.statusText} - ${errorText}`);
    }

    return await response.json();
};